import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import { NerdWalletRating } from 'src/features/product-card/NerdWalletRating';
import type { CellProps } from '../types';
export const Rating = t0 => {
  const $ = _c(11);
  const {
    creditCardOffer,
    isMonetizing,
    title
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    reviewLink,
    starRating
  } = t1;
  let t2;
  if ($[0] !== creditCardOffer.name || $[1] !== isMonetizing || $[2] !== reviewLink || $[3] !== starRating) {
    t2 = <NerdWalletRating variant="roundup" reviewLink={reviewLink} starRating={starRating} isMonetizing={isMonetizing} excludeLabel={true} name={creditCardOffer.name} />;
    $[0] = creditCardOffer.name;
    $[1] = isMonetizing;
    $[2] = reviewLink;
    $[3] = starRating;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      color: "grey.600",
      marginTop: 2
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <Typography data-testid="best-for-text" variant="textSmall" sx={t3}>{"Best for "}{title}</Typography>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};